/**
 * Agence'O - popin
 * @author Axel Baron (Agence'O)
 * @created 04/04/2019
 */

(function ($) {

  $(document).on('click', '.js-pop-in', (e) => {
    e.preventDefault();
    let $current = $(e.currentTarget);
    let target = $current.data('target');
    $(target).show();
   // $('body').addClass('no-scroll');
  });

  $(document).on('click', '.js-pop-in-close', (e) => {
    e.preventDefault();
    let $current = $(e.currentTarget);
    $current.parent().parent().parent().hide();
    $('body').removeClass('no-scroll');
  });

}(jQuery));
